import search from '../../src/views/archives/search'
import list from '../../src/views/archives/list'

export default {
  search:search,
  list:list,
}